import React, { useMemo, useRef, useState } from 'react';
import { Platform } from 'react-native';
import { router } from 'expo-router';
import { useAuthStore, useChatStore } from '@/store';
import useResponsiveness from '@/hooks/useResponsiveness';
import { recentDiscoveryIdeas } from '@/lib/discoveryExperience';
import useDiscoveryContinuations from '@/hooks/useDiscoveryContinuations';
import { queueDiscoveryContinuation } from '@/lib/discoveryContinuation';
import RecentDiscoveryCards from './RecentDiscoveryCards';

export default function RecentDiscovery({ mode, palette, onUse }) {
  const { isXS } = useResponsiveness();
  const compact = isXS || Platform.OS === 'ios' || Platform.OS === 'android';
  const userId = useAuthStore(s => s.user?.id);
  const session = useAuthStore(s => s._sessionGeneration);
  const enabled = useAuthStore(s => s.user?.preferences?.chat?.followUpSuggestionsEnabled !== false);
  const chats = useChatStore(s => s.chats);
  const [sending, setSending] = useState(null);
  const sendingRef = useRef(false);
  const candidates = useMemo(() => userId && enabled ? recentDiscoveryIdeas(chats, mode).slice(0, compact ? 1 : 3) : [], [chats, mode, userId, enabled, compact]);
  const ideas = useDiscoveryContinuations(candidates, mode, enabled);
  if (!ideas.length) return null;
  const resume = idea => {
    if (sendingRef.current || !idea.prompt) return;
    sendingRef.current = true; setSending(idea.id);
    queueDiscoveryContinuation({ conversationId: idea.conversationId, userId, session, prompt: idea.prompt });
    onUse?.(idea, 'used');
    router.push(`/c/${idea.conversationId}`);
  };
  return <RecentDiscoveryCards ideas={ideas} palette={palette} compact={compact} sending={sending}
    onOpen={idea => router.push(`/c/${idea.conversationId}`)} onContinue={resume} />;
}
